export default __webpack_public_path__ + "static/social-future-35million-da415ce3ae685dff62bd12c3329a74c2.jpg";